import { createContext, useContext, useState, type ReactNode } from 'react';

/**
 * Global context for triggering the Log Deliverable modal.
 * Consumed by AgencyShell (topbar button) and LogDeliverableModal.
 */

interface LogDeliverableContextValue {
  isOpen: boolean;
  open: () => void;
  close: () => void;
}

const LogDeliverableContext = createContext<LogDeliverableContextValue | undefined>(undefined);

export function LogDeliverableProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <LogDeliverableContext.Provider
      value={{ isOpen, open: () => setIsOpen(true), close: () => setIsOpen(false) }}
    >
      {children}
    </LogDeliverableContext.Provider>
  );
}

export function useLogDeliverable(): LogDeliverableContextValue {
  const ctx = useContext(LogDeliverableContext);
  if (!ctx) throw new Error('useLogDeliverable must be used inside <LogDeliverableProvider>');
  return ctx;
}
